<template>
    <div class="lnk-imgviewer" :style="cStyle">
        <img class="lnk-imgviewer-bigpic"
             ref="bigpic"
             @load="onLoad"
             @error="onError"
             :src="src"
             :loading="isLoading"
             :preview="group"
             :preview-text="title"/>
        <img class="lnk-imgviewer-thumb"
             v-show="isValid"
             @click="showBigPic"
             :src="smallUrl || url"/>
        <img v-show="!isValid"
             class="lnk-imgviewer-error"
             :src="errorUrl"/>
    </div>
</template>

<script>

export default {
    name: 'lnk-imgviewer',
    data(){
        return {
            src: '',
            group: this.groupId || this._uid,
            isValid: true,
            isLoading: false,
            errSrc: this.errorUrl
        };
    },
    props: {
        /* 图片路径*/
        url: String,
        smallUrl: String,
        errorUrl: String,
        groupId: String,
        title: String,
        height: [String, Number],
        width: [String, Number]
    },
    computed: {
        cStyle(){
            const style = {};
            if(this.width!==undefined && !isNaN(this.width)){
                style.width = this.width+'px';
            }
            if(this.height!==undefined && !isNaN(this.height)){
                style.height = this.height+'px';
            }
            return style;
        }
    },
    watch: {
        /* 响应图片路径的变化*/
        url: {
            immediate: true,
            handler: function (val) {
                this.src = val || ' ';
                this.isLoading = true;
            }
        },
        errorUrl: {
            immediate: true,
            handler: function (val) {
                this.errSrc = val;
            }
        },
        groupId: {
            immediate: true,
            handler: function (val) {
                if(!val) return;
                this.group = val;
            }
        }
    },
    methods: {
        onLoad() {
            this.isLoading = false;
            this.isValid = true;
        },
        onError() {
            this.isLoading = false;
            this.isValid = false;
        },
        showBigPic(){
            this.$refs.bigpic.click();
        }
    }
};
</script>

<style scoped lang="scss">
    .lnk-imgviewer{
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        .lnk-imgviewer-thumb{
            cursor: pointer;
        }
        .lnk-imgviewer-thumb,
        .lnk-imgviewer-error{
            width: 100%;
            height: 100%;
        }
        .lnk-imgviewer-bigpic{
            position: absolute;
            top:50%;
            left: 50%;
            width: 1px;
            height: 0px;
        }
    }
</style>
